"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _Button = require("../Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyle = (0, _makeStyles.default)({
  root: function root(_ref) {
    var intent = _ref.intent,
        disabled = _ref.disabled;
    return {
      width: '32px',
      height: '32px',
      padding: 0,
      transition: 'none',
      borderRadius: '4px',
      backgroundColor: _Button.btnStyle[intent],
      opacity: disabled ? 0.5 : 1,
      '& > span > svg > path': {
        fill: intent === 'tertiary' ? _Colors.default.secondaryGrey : ''
      },
      '&.Mui-disabled': {
        backgroundColor: _Button.btnStyle[intent]
      },
      '&:focus': {
        boxShadow: "0px 0px 6px ".concat(_Button.btnStyle[intent]),
        '& > span > svg > path': {
          fill: intent === 'tertiary' ? _Colors.default.tertiaryGrey : ''
        }
      },
      '&:hover': {
        backgroundColor: _Button.btnStyle[intent],
        opacity: 0.75,
        boxShadow: intent === 'tertiary' ? '' : '0px 2px 4px rgba(0, 0, 0, 0.5)',
        '& > span > svg > path': {
          fill: intent === 'tertiary' ? _Colors.default.textElementGrey : ''
        }
      },
      '&:active': {
        opacity: 1,
        backgroundColor: _Button.btnStyleActive[intent],
        '& > span > svg > path': {
          fill: intent === 'tertiary' ? _Colors.default.textElementGrey : ''
        }
      },
      '& .MuiButtonBase-root .Mui-disabled': {
        opacity: 1,
        backgroundColor: _Button.btnStyle[intent]
      }
    };
  },
  loaderIcon: function loaderIcon(_ref2) {
    var intent = _ref2.intent;
    return {
      display: 'flex',
      color: intent === 'tertiary' ? _Colors.default.textElementGrey : _Colors.default.white
    };
  },
  iconButtonWrapper: function iconButtonWrapper(_ref3) {
    var margin = _ref3.margin;
    return {
      margin: margin
    };
  }
});

var IconButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var onClick = props.onClick,
      intent = props.intent,
      disabled = props.disabled,
      isLoading = props.isLoading,
      icon = props.icon,
      margin = props.margin;

  var _useStyle = useStyle({
    disabled: disabled,
    intent: intent,
    margin: margin
  }),
      root = _useStyle.root,
      iconButtonWrapper = _useStyle.iconButtonWrapper,
      loaderIcon = _useStyle.loaderIcon;

  return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    ref: ref,
    classes: {
      root: root
    },
    className: iconButtonWrapper,
    disabled: disabled,
    onClick: onClick,
    disableRipple: true,
    "data-testid": props['data-testid'],
    size: "large"
  }, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: loaderIcon
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    color: "inherit",
    size: 24
  })) : icon(intent === 'tertiary' ? _Colors.default.secondaryGrey : _Colors.default.white));
});

var _default = IconButton;
exports.default = _default;